import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
import { cn } from "../../lib/utils";
/**
 * Input component.
 *
 * UX Notes:
 * - Min height 44px for touch targets
 * - Visible focus ring
 * - Use with visible <label> — never placeholder-only
 * - Use semantic input types for mobile keyboards
 */
const Input = React.forwardRef(({ className, type, ...props }, ref) => {
    return (_jsx("input", { type: type, className: cn("flex h-11 w-full rounded-md border border-input bg-transparent px-3 py-2", "text-base transition-colors duration-200", "file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground", "placeholder:text-muted-foreground", "focus-visible:border-ring focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-ring", "disabled:cursor-not-allowed disabled:opacity-50", className), ref: ref, ...props }));
});
Input.displayName = "Input";
export { Input };
//# sourceMappingURL=input.js.map